import { useAuth } from '@/contexts/AuthContext';
import { isTestUser } from '@/utils/testUser';
import { PRICING_CONFIG } from '@/config/pricing';

export function TestModeBanner() {
  const { user } = useAuth();
  
  const isSimulatedPaidUser = PRICING_CONFIG?.simulatePaidUser === true;
  const isTestUserActive = isTestUser(user?.email);
  
  if (!isSimulatedPaidUser && !isTestUserActive) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-warning text-warning-foreground text-center py-2 px-4 text-sm font-medium">
      {isSimulatedPaidUser 
        ? "Test mode enabled. All Pro features and Document Pack are unlocked. Set simulatePaidUser: false in src/config/pricing.ts to disable."
        : "Test mode. You are seeing iso27001kit.com as a paid user. Real payments are not required for this account."
      }
    </div>
  );
}
